import React from "react";
import styled from "styled-components";

import FilterChip from "../filter-chip/FilterChip";

/**
 * 支払明細書の年度フィルター（グローバルコンポーネント）。
 *
 * データの存在する年（`years`）だけを新しい順にタグ表示し、末尾に「すべて」を置く。
 * データの無い年は表示しない（当年でもデータが無ければ出さない）。
 * 直近 2 年は「今年」「去年」、それ以前は「YYYY年」と表示する。
 */
export type PaymentYearSelection = number | "all";

export interface PaymentYearFilterProps {
  /** データが存在する年（順不同で可。内部で降順整列する）。 */
  years: number[];
  /** 選択中の年（数値）または "all"。 */
  selected: PaymentYearSelection;
  // eslint-disable-next-line no-unused-vars
  onSelect: (year: PaymentYearSelection) => void;
  className?: string;
}

const Bar = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  overflow-x: auto;
  padding: 4px 0 12px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  /* 横スクロールするバーなので各タグは縮めない。 */
  & > * {
    flex-shrink: 0;
  }
`;

const labelForYear = (year: number, currentYear: number): string => {
  if (year === currentYear) return "今年";
  if (year === currentYear - 1) return "去年";
  return `${year}年`;
};

const PaymentYearFilter: React.FC<PaymentYearFilterProps> = ({
  years,
  selected,
  onSelect,
  className,
}) => {
  const currentYear = new Date().getFullYear();
  // データが存在する年だけを降順に表示する（当年でもデータが無ければ出さない）。
  const displayYears = [...years].sort((a, b) => b - a);

  return (
    <Bar className={className}>
      {displayYears.map((year) => (
        <FilterChip
          key={year}
          selected={selected === year}
          onClick={() => onSelect(year)}
          className="u-flex-shrink-0"
        >
          {labelForYear(year, currentYear)}
        </FilterChip>
      ))}
      <FilterChip
        selected={selected === "all"}
        onClick={() => onSelect("all")}
        className="u-flex-shrink-0"
      >
        すべて
      </FilterChip>
    </Bar>
  );
};

export default PaymentYearFilter;
